import { render } from "./AdminLanguages.component.vue?vue&type=template&id=87760446"
import script from "./AdminLanguages.component.vue?vue&type=script&lang=js"
export * from "./AdminLanguages.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__